import React from "react";
import FullCalendar from "@fullcalendar/react";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Badge,
  Button,
  Drawer,
  Empty,
  Input,
  List,
  Select,
  Space,
  Tag,
  message,
} from "antd";
import { apiCallPost } from "../fns/util";
import {
  CheckSquareOutlined,
  MoreOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import SessionDetails from "./SessionDetails";
import { QuickScore } from "quick-score";
import Commitments from "./Commitments";

class SchedulerLayout extends React.Component {
  state = {
    calendarResolution: this.props.calendarResolution || "00:30:00",
    isBusy: false,
    isDrawerOpen: false,
    events: [],
    sponsors: [],
    resources: [
      {
        id: "Hall A",
        title: "Hall A",
      },
      {
        id: "Hall B",
        title: "Hall B",
      },
      {
        id: "Hall C",
        title: "Hall C",
      },
      {
        id: "Hall D",
        title: "Hall D",
      },
      {
        id: "Hall E",
        title: "Hall E",
      },
      {
        id: "DSTC Arena",
        title: "DSTC Arena",
      },
    ],
    initialResources: [
      {
        id: "Hall A",
        title: "Hall A",
      },
      {
        id: "Hall B",
        title: "Hall B",
      },
      {
        id: "Hall C",
        title: "Hall C",
      },
      {
        id: "Hall D",
        title: "Hall D",
      },
      {
        id: "Hall E",
        title: "Hall E",
      },
      {
        id: "DSTC Arena",
        title: "DSTC Arena",
      },
    ],
    loadedSubmissions: [],
    searchedSubmissions: [],
    currentlySelectedSubmissionIds: [],
    currentlySelectedSessionId: null,
    currentlyViewingScheduleForDays:
      this.props.currentlyViewingScheduleForDays || "All Days",
    currentlyViewingScheduleForHalls:
      this.props.currentlyViewingScheduleForHalls || "All Halls",
    currentlyHoveringMouseSessionId: null,
    mode: "VIEW",
    submissionSearchInput: "",
    submissionFilterAward: "",
    submissionFilterType: "",
    commitments: [],
  };
  calendarRef = React.createRef();
  componentDidMount() {
    this.getAllEvents();
    this.getAllSponsors();
    this.getAllConflicts();
    this.getAllSubmissions();
    if (this.props.setDay === "1") {
      let calendarApi = this.calendarRef.current.getApi();
      calendarApi.changeView("day1View", "2023-12-15");
      this.setState({
        currentlyViewingScheduleForDays: "Day 1",
      });
    }
    if (this.props.setDay === "2") {
      let calendarApi = this.calendarRef.current.getApi();
      calendarApi.changeView("day1View", "2023-12-16");
      this.setState({
        currentlyViewingScheduleForDays: "Day 2",
      });
    }
    if (this.props.setDay === "3") {
      let calendarApi = this.calendarRef.current.getApi();
      calendarApi.changeView("day1View", "2023-12-17");
      this.setState({
        currentlyViewingScheduleForDays: "Day 3",
      });
    }
  }
  darkenHexColor = (hexColor, percent) => {
    // Convert hex to RGB
    let bigint = parseInt(hexColor.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    // Darken the RGB values
    const factor = 1 - percent;
    r = Math.floor(r * factor);
    g = Math.floor(g * factor);
    b = Math.floor(b * factor);

    // Convert RGB back to hex
    return (
      "#" +
      ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()
    );
  };
  mapSessionsToEvents = (sessions) => {
    let events = [];
    if (!sessions) {
      this.setState({
        events: [],
      });
      return;
    }
    if (!sessions.length) {
      this.setState({
        events: [],
      });
      return;
    }

    events = sessions.map((each) => {
      let bg = each.sessionType
        ? this.sessionColourMaps[each.sessionType]
        : this.sessionColourMaps.SESSION;
      let border = this.darkenHexColor(bg, 0.1);
      return {
        ...each,
        id: each._id,
        startEditable: true,
        eventResizableFromStart: true,
        durationEditable: true,
        resourceEditable: true,
        backgroundColor: bg,
        borderColor: border,
      };
    });
    this.setState({
      events,
    });
  };
  getAllEvents = async () => {
    // let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023/getAllSessions";
    try {
      let { sessions } = await apiCallPost("token", apiUrl, {});
      this.mapSessionsToEvents(sessions);
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  getAllSponsors = async () => {
    if (!this.props.isAdmin) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/getAllSponsors";
    try {
      let { sponsors } = await apiCallPost(token, apiUrl, {});
      sponsors = sponsors.map((each) => each.name);
      this.setState({
        sponsors,
      });
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  getAllSubmissions = async () => {
    if (!this.props.isAdmin) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/findAcceptedSubmissions";
    try {
      let { submissions } = await apiCallPost(token, apiUrl, {
        isScheduled: false,
        submissionTypeIn: ["PAPER", "VIDEO", "IC", "THESIS", "OPC"],
      });
      this.setState({
        loadedSubmissions: submissions,
        searchedSubmissions: submissions,
      });
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  addSubmissionToSession = async () => {
    /**
     * addEventToSession {sessionId, eventId}
     */
    if (this.state.isBusy) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/addEventToSession";
    let submissionIds = this.state.currentlySelectedSubmissionIds;
    let sessionId = this.state.currentlyHoveringMouseSessionId;
    // if blank return
    if (!sessionId) {
      return;
    }
    if (!submissionIds.length) {
      return;
    }
    // use Promise.all

    try {
      this.setState({
        isBusy: true,
      });
      message.loading("Adding Submission To Session...");
      await Promise.all(
        submissionIds.map(async (submissionId) => {
          await apiCallPost(token, apiUrl, {
            sessionId,
            eventId: submissionId,
          });
        })
      );
      // remove these sessionIds from the loadedSubmissions, and reset search results

      let newSubmissions = this.state.loadedSubmissions.filter(
        (each) => !submissionIds.includes(each._id)
      );

      this.setState(
        {
          loadedSubmissions: newSubmissions,
          isBusy: false,
          currentlySelectedSubmissionIds: [],
        },
        () => {
          this.quickSearchSubmissions();
        }
      );
      message.success("Submission Added To Session");
      //  this.getAllEvents();
    } catch (err) {
      console.log(err);
      message.error("Error Adding Submission To Session");
      this.setState({ isBusy: false });
    }
  };

  ALL_ROLES = [
    "Anchor",
    "Chairperson",
    "Chief Instructor",
    "Chronographer",
    "Co-Chairperson",
    "Coordinator",
    "Chief Umpire",
    "Umpire",
    "Honoured Referee",
    "Referee",
    "Lead Talk",
    "Debater",
    "Discussant",
    "Hall Moderator",
    "Instructor",
    "Judge",
    "Keynote Speaker",
    "Master",
    "Mentee",
    "Mentee - Cataract",
    "Mentor",
    "Mentor - Cataract",
    "Moderator",
    "Neuro-Ophthalmology",
    "OT Moderator",
    "Oculoplasty",
    "Orator",
    "Panelist",
    "Participant",
    "Presenter",
    "Quizmaster",
    "Retina",
    "Speaker",
    "Storyteller",
    "Surgeon",
    "Team Captain",
    "Team Member",
    "Wise Counsel",
  ];

  sessionTypes = {
    SYMPOSIUM: this.ALL_ROLES,
    INSTRUCTION_COURSE: this.ALL_ROLES,
    DEBATE: this.ALL_ROLES,
    QUIZ: this.ALL_ROLES,
    ORATION: this.ALL_ROLES,
    WORKSHOP: this.ALL_ROLES,
    COMPETITION: this.ALL_ROLES,
    LIVE_SURGERY: this.ALL_ROLES,
    SESSION: this.ALL_ROLES,
  };

  // sessionTypes = {
  //   SYMPOSIUM: [
  //     "Chairperson",
  //     "Co-Chairperson",
  //     "Coordinator",
  //     "Moderator",
  //     "Keynote Speaker",
  //     "Panelist",
  //     "Presenter",
  //     "Participant",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   INSTRUCTION_COURSE: [
  //     "Chairperson",
  //     "Co-Chairperson",
  //     "Coordinator",
  //     "Moderator",
  //     "Keynote Speaker",
  //     "Chief Instructor",
  //     "Instructor",
  //     "Panelist",
  //     "Presenter",
  //     "Participant",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   DEBATE: [
  //     "Chairperson",
  //     "Coordinator",
  //     "Co-Chairperson",
  //     "Judge",
  //     "Moderator",
  //     "Participant",
  //     "Presenter",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   ORATION: [
  //     "Chairperson",
  //     "Coordinator",
  //     "Co-Chairperson",
  //     "Orator",
  //     "Coordinator",
  //     "Moderator",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   QUIZ: [
  //     "Chairperson",
  //     "Coordinator",
  //     "Co-Chairperson",
  //     "Judge",
  //     "Quizmaster",
  //     "Moderator",
  //     "Participant",
  //     "Presenter",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   WORKSHOP: [
  //     "Coordinator",
  //     "Chairperson",
  //     "Co-Chairperson",
  //     "Judge",
  //     "Moderator",
  //     "Panelist",
  //     "Participant",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   COMPETITION: [
  //     "Chairperson",
  //     "Coordinator",
  //     "Co-Chairperson",
  //     "Judge",
  //     "Coordinator",
  //     "Presenter",
  //     "Participant",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   LIVE_SURGERY: [
  //     "Coordinator",
  //     "Chairperson",
  //     "Co-Chairperson",
  //     "Moderator",
  //     "Presenter",
  //     "Panelist",
  //     "Surgeon",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  //   SESSION: [
  //     "Chairperson",
  //     "Co-Chairperson",
  //     "Judge",
  //     "Coordinator",
  //     "Moderator",
  //     "Panelist",
  //     "Presenter",
  //     "Participant",
  //     "Mentor",
  //     "Mentee",
  //     "Mentor - Cataract",
  //     "Mentee - Cataract",
  //     "Retina",
  //     "Oculoplasty",
  //     "Neuro-Ophthalmology",
  //     "Wise Counsel",
  //     "OT Moderator",
  //     "Hall Moderator",
  //     "Speaker",
  //     "Chronographer",
  //     "Anchor",
  //     "Storyteller",
  //     "Team Captain",
  //     "Team Member",
  //     "Discussant",
  //     "Debater",
  //   ],
  // };

  sessionColourMaps = {
    SYMPOSIUM: "#7AE1D8",
    INSTRUCTION_COURSE: "#D4F17E",
    DEBATE: "#FBD065",
    QUIZ: "#F0D0AD",
    ORATION: "#D69FD6",
    WORKSHOP: "#D1E1FF",
    COMPETITION: "#BDADFF",
    LIVE_SURGERY: "#68C1EE",
    SESSION: "#E8F8B6",
    NONE: "#DCE0E5",
  };
  views = {
    allConferenceDays: {
      type: "resourceTimeGrid",
      duration: { days: 3 },
      validRange: {
        start: "2023-12-15",
        end: "2023-12-18",
      },
    },
    day1View: {
      type: "resourceTimeGrid",
      duration: { days: 1 },

      validRange: {
        start: "2023-12-15",
        end: "2023-12-16",
      },
    },
    day2View: {
      type: "resourceTimeGrid",
      duration: { days: 1 },

      validRange: {
        start: "2023-12-16",
        end: "2023-12-17",
      },
    },
    day3View: {
      type: "resourceTimeGrid",
      duration: { days: 1 },

      validRange: {
        start: "2023-12-17",
        end: "2023-12-18",
      },
    },
  };
  customButtons = {
    headerButton: {
      text: `${this.state.currentlyViewingScheduleForDays} - ${this.state.currentlyViewingScheduleForHalls}`,
    },
    allHallsButton: {
      text: "All Halls",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "All Halls",
          resources: this.state.initialResources,
        });
      },
    },
    hallAButton: {
      text: "Hall A",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "Hall A",
          resources: [
            {
              id: "Hall A",
              title: "Hall A",
            },
          ],
        });
      },
    },
    hallBButton: {
      text: "Hall B",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "Hall B",
          resources: [
            {
              id: "Hall B",
              title: "Hall B",
            },
          ],
        });
      },
    },
    hallCButton: {
      text: "Hall C",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "Hall C",
          resources: [
            {
              id: "Hall C",
              title: "Hall C",
            },
          ],
        });
      },
    },
    hallDButton: {
      text: "Hall D",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "Hall D",
          resources: [
            {
              id: "Hall D",
              title: "Hall D",
            },
          ],
        });
      },
    },
    hallEButton: {
      text: "Hall E",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "Hall E",
          resources: [
            {
              id: "Hall E",
              title: "Hall E",
            },
          ],
        });
      },
    },
    hallArenaButton: {
      text: "DSTC Arena",
      click: () => {
        this.setState({
          currentlyViewingScheduleForHalls: "DSTC Arena",
          resources: [
            {
              id: "DSTC Arena",
              title: "DSTC Arena",
            },
          ],
        });
      },
    },
    allDaysButton: {
      text: "All Days",
      click: () => {
        let calendarApi = this.calendarRef.current.getApi();
        calendarApi.changeView("allConferenceDays", "2023-12-15");
        this.setState({
          currentlyViewingScheduleForDays: "All Days",
        });
      },
    },
    day1Button: {
      text: "Day 1",
      click: () => {
        let calendarApi = this.calendarRef.current.getApi();
        calendarApi.changeView("day1View", "2023-12-15");
        this.setState({
          currentlyViewingScheduleForDays: "Day 1",
        });
      },
    },
    day2Button: {
      text: "Day 2",
      click: () => {
        let calendarApi = this.calendarRef.current.getApi();
        calendarApi.changeView("day2View", "2023-12-16");
        this.setState({
          currentlyViewingScheduleForDays: "Day 2",
        });
      },
    },
    day3Button: {
      text: "Day 3",
      click: () => {
        let calendarApi = this.calendarRef.current.getApi();
        calendarApi.changeView("day3View", "2023-12-17");
        this.setState({
          currentlyViewingScheduleForDays: "Day 3",
        });
      },
    },
  };
  quickSearchSubmissions = () => {
    let submissions = this.state.loadedSubmissions;
    let resultItems = this.state.loadedSubmissions;
    if (
      this.state.submissionSearchInput &&
      this.state.submissionSearchInput.length > 2
    ) {
      const qs = new QuickScore(submissions, ["title", "presentingAuthorName"]);
      const results = qs.search(this.state.submissionSearchInput);
      resultItems = results.map((each) => each.item);
    }
    if (this.state.submissionFilterAward) {
      resultItems = resultItems.filter(
        (each) => each.awardTrack === this.state.submissionFilterAward
      );
    }
    if (this.state.submissionFilterType) {
      resultItems = resultItems.filter(
        (each) => each.submissionType === this.state.submissionFilterType
      );
    }
    this.setState({
      searchedSubmissions: resultItems,
    });
  };
  renderEventContent = (eventInfo) => {
    let sessionType = eventInfo.event.extendedProps.sessionType;
    let niceSessionType = _.startCase(_.lowerCase(sessionType));
    let border = eventInfo.event.borderColor;
    let darkenedBorder = this.darkenHexColor(border, 0.35);
    let evenMoreDarkened = this.darkenHexColor(border, 0.8);
    let eventDuration =
      (eventInfo.event.end - eventInfo.event.start) / (1000 * 60 * 60);
    let mode = this.state.mode;
    let isAdd = mode === "ADD";
    let isHovering =
      this.state.currentlyHoveringMouseSessionId === eventInfo.event.id;
    let lcssi = this.state.currentlySelectedSubmissionIds.length;
    let showHover = isHovering && isAdd && lcssi >= 1;
    let addButton = (
      <div
        style={{
          color: evenMoreDarkened,
          fontSize: "x-small",
        }}
      >
        <PlusCircleOutlined />
        Add Here
      </div>
    );
    if (eventDuration < 0.5) {
      return (
        <div>
          <div
            style={{
              color: evenMoreDarkened,
              fontSize: "xx-small",
            }}
          >
            {showHover ? <>{addButton}</> : null}
            {eventInfo.event.title}
          </div>
        </div>
      );
    } else if (eventDuration < 0.75) {
      return (
        <div>
          <div
            style={{
              color: evenMoreDarkened,
              fontSize: "x-small",
            }}
          >
            {showHover ? <>{addButton}</> : null}
            {eventInfo.event.title}
          </div>
        </div>
      );
    } else if (eventDuration < 1.5) {
      return (
        <div>
          <div
            style={{
              backgroundColor: darkenedBorder,
              padding: "3px",
              fontSize: "x-small",
            }}
          >
            {niceSessionType}
          </div>
          {showHover ? <>{addButton}</> : null}
          <div
            style={{
              color: evenMoreDarkened,
            }}
          >
            {eventInfo.event.title}
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ margin: "3px" }}>
          <div
            style={{
              backgroundColor: darkenedBorder,
              padding: "3px",
              fontSize: "x-small",
            }}
          >
            {niceSessionType}
          </div>{" "}
          {showHover ? <>{addButton}</> : null}
          <div
            style={{
              color: evenMoreDarkened,
            }}
          >
            {eventInfo.event.title}
          </div>
        </div>
      );
    }
  };
  handleEventClick = (clickInfo) => {
    if (this.state.isBusy) {
      return;
    }
    if (this.state.mode === "ADD") {
      if (this.state.currentlySelectedSubmissionIds.length === 0) {
        this.setState({
          currentlySelectedSessionId: clickInfo.event.id,
        });
        return;
      } else {
        this.addSubmissionToSession();
        return;
      }
    } else if (["EDIT", "VIEW", "CONFLICT"].includes(this.state.mode)) {
      this.setState({
        currentlySelectedSessionId: clickInfo.event.id,
      });
      return;
    }
  };
  getAllConflicts = async () => {
    if (!this.props.isAdmin) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/getAllConflicts";
    try {
      let res = await apiCallPost(token, apiUrl, {});
      this.setState({
        commitments: res.commitments,
      });
    } catch (err) {
      console.log(err);
      this.setState({ isLoading: false, isError: true });
    }
  };
  handleCreateNewEvent = async (selectInfo) => {
    if (!this.props.isAdmin) {
      return null;
    }
    if (this.state.isBusy) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/createSession";
    let whichDay = "";
    switch (selectInfo.start.getDate()) {
      case 15:
        whichDay = "DAY 1";
        break;
      case 16:
        whichDay = "DAY 2";
        break;
      case 17:
        whichDay = "DAY 3";
        break;
      default:
        whichDay = "";
    }
    if (!whichDay) {
      return;
    }
    try {
      this.setState({
        isBusy: true,
      });
      message.loading("Creating Session...");
      const { session } = await apiCallPost(token, apiUrl, {
        start: selectInfo.start,
        end: selectInfo.end,
        resourceId: selectInfo.resource.id,
        onDay: whichDay,
      });
      let newSessArr = [session];
      let events = newSessArr.map((each) => {
        let bg = each.sessionType
          ? this.sessionColourMaps[each.sessionType]
          : this.sessionColourMaps.SESSION;
        let border = this.darkenHexColor(bg, 0.1);
        return {
          ...each,
          id: each._id,
          startEditable: true,
          eventResizableFromStart: true,
          durationEditable: true,
          resourceEditable: true,
          backgroundColor: bg,
          borderColor: border,
        };
      });
      this.setState({
        isBusy: false,
        events: [...this.state.events, ...events],
        currentlySelectedSessionId: session._id,
      });
      message.success("Session Created");
    } catch (err) {
      console.log(err);
      message.error("Error Creating Session");
      this.setState({ isBusy: false });
    }
  };
  saveSession = async (session) => {
    if (!this.props.isAdmin) {
      return null;
    }
    if (this.state.isBusy) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/editSession";
    try {
      this.setState({
        isBusy: true,
      });
      message.loading("Saving Session...");
      const { session: updatedSession } = await apiCallPost(token, apiUrl, {
        sessionId: session._id,
        session: session,
      });
      let events = this.state.events.map((each) => {
        if (each._id === updatedSession._id) {
          let bg = updatedSession.sessionType
            ? this.sessionColourMaps[updatedSession.sessionType]
            : this.sessionColourMaps.SESSION;
          let border = this.darkenHexColor(bg, 0.1);
          return {
            ...updatedSession,
            id: updatedSession._id,
            startEditable: true,
            eventResizableFromStart: true,
            durationEditable: true,
            resourceEditable: true,
            backgroundColor: bg,
            borderColor: border,
          };
        }
        return each;
      });
      this.setState({
        isBusy: false,
        events,
      });
      message.success("Session Saved");
    } catch (err) {
      console.log(err);
      message.error("Error Saving Session");
      this.setState({ isBusy: false });
    }
  };
  updateSessionMetadata = async (
    sessionId,
    start,
    end,
    resourceId,
    changeInfo
  ) => {
    if (this.state.isBusy) {
      return null;
    }
    if (!this.props.isAdmin) {
      changeInfo.revert();
      return;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/editSession";
    try {
      this.setState({
        isBusy: true,
      });
      message.loading("Updating Session...");
      let sessionIdx = _.findIndex(
        this.state.events,
        (x) => x._id === sessionId
      );
      let session = this.state.events[sessionIdx];
      session.start = start;
      session.end = end;
      session.resourceId = resourceId;
      const { session: updatedSession } = await apiCallPost(token, apiUrl, {
        sessionId: sessionId,
        session: session,
      });
      let events = this.state.events.map((each) => {
        if (each._id === updatedSession._id) {
          let bg = updatedSession.sessionType
            ? this.sessionColourMaps[updatedSession.sessionType]
            : this.sessionColourMaps.SESSION;
          let border = this.darkenHexColor(bg, 0.1);
          return {
            ...updatedSession,
            id: updatedSession._id,
            startEditable: true,
            eventResizableFromStart: true,
            durationEditable: true,
            resourceEditable: true,
            backgroundColor: bg,
            borderColor: border,
          };
        }
        return each;
      });
      this.setState({
        isBusy: false,
        events,
      });
      message.success("Session Updated");
    } catch (err) {
      console.log(err);
      message.error("Error Updating Session");
      this.setState({ isBusy: false });
    }
  };
  deleteSession = async (sessionId) => {
    if (this.state.isBusy) {
      return null;
    }
    let token = await this.props.context.provideToken();
    let apiUrl = "/conference2023admin/deleteSession";
    try {
      message.loading("Deleting Session...");
      this.setState({
        isBusy: true,
      });
      await apiCallPost(token, apiUrl, {
        sessionId: sessionId,
      });
      let events = this.state.events.filter((each) => each._id !== sessionId);
      this.setState({
        isBusy: false,
        events,
        currentlySelectedSessionId: null,
      });
      message.success("Session Deleted");
    } catch (err) {
      console.log(err);
      message.error("Error Deleting Session");
      this.setState({ isBusy: false });
    }
  };
  renderSelectedSessionDrawer = () => {
    if (!this.state.currentlySelectedSessionId) {
      return null;
    }
    let sessionIdx = _.findIndex(
      this.state.events,
      (x) => x.id === this.state.currentlySelectedSessionId
    );
    let session = this.state.events[sessionIdx];
    let title = session.title || "Untitled Session";
    return (
      <Drawer
        title={title}
        placement="right"
        closable={true}
        open={this.state.currentlySelectedSessionId !== null}
        size="large"
        onClose={() => {
          this.setState({
            currentlySelectedSessionId: null,
          });
        }}
      >
        <SessionDetails
          mode={this.state.mode}
          key={`session_details__${session._id}__${session.updatedAt}__${this.state.isBusy}`}
          isBusy={this.state.isBusy}
          context={this.props.context}
          session={session}
          isAdmin={this.props.isAdmin}
          saveSession={this.saveSession}
          deleteSession={this.deleteSession}
          sessionTypes={this.sessionTypes}
          sponsors={this.state.sponsors}
          setMode={(mode) => {
            this.setState({
              mode,
            });
          }}
        />
      </Drawer>
    );
  };
  renderCalendar = () => {
    let resolutionOptions = [
      {
        label: "15 minutes",
        value: "00:15:00",
      },
      {
        label: "30 minutes",
        value: "00:30:00",
      },
      {
        label: "45 minutes",
        value: "00:45:00",
      },
      {
        label: "60 minutes",
        value: "00:60:00",
      },
    ];
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Tag>
            {" "}
            Viewing Schedules For:{" "}
            {`${this.state.currentlyViewingScheduleForDays} - ${this.state.currentlyViewingScheduleForHalls}`}{" "}
            | Mode: {_.startCase(_.lowerCase(this.state.mode))}
          </Tag>
          <div>
            Resolution:{" "}
            <Select
              options={resolutionOptions}
              value={this.state.calendarResolution}
              onChange={(value) => {
                this.setState({
                  calendarResolution: value,
                });
              }}
            ></Select>
            {this.props.isAdmin && (
              <Button
                onClick={() => {
                  this.setState({
                    mode: "VIEW",
                  });
                }}
              >
                View Schedule
              </Button>
            )}
            {this.props.isAdmin && (
              <Button
                onClick={() => {
                  this.setState(
                    {
                      loadedSubmissions: [],
                      searchedSubmissions: [],
                      currentlySelectedSubmissionIds: [],
                      currentlySelectedSessionId: null,
                      currentlyViewingScheduleForDays: "All Days",
                      currentlyViewingScheduleForHalls: "All Halls",
                      currentlyHoveringMouseSessionId: null,
                      mode: "ADD",
                      submissionSearchInput: "",
                      submissionFilterAward: "",
                      submissionFilterType: "",
                    },
                    () => this.getAllSubmissions()
                  );
                }}
              >
                Add Submissions To Sessions
              </Button>
            )}
            {this.props.isAdmin && (
              <Button
                onClick={() => {
                  this.setState({
                    mode: "EDIT",
                  });
                }}
              >
                Edit Sessions
              </Button>
            )}
            {this.props.isAdmin && (
              <Button
                onClick={() => {
                  this.setState(
                    {
                      mode: "CONFLICT",
                    },
                    () => this.getAllConflicts()
                  );
                }}
              >
                View Commitments
              </Button>
            )}
          </div>
        </div>
        <FullCalendar
          ref={this.calendarRef}
          height="75vh"
          expandRows={false}
          plugins={[resourceTimeGridPlugin, interactionPlugin]}
          schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
          customButtons={this.customButtons}
          headerToolbar={{
            end: "allHallsButton hallAButton,hallBButton,hallCButton,hallDButton,hallEButton,hallArenaButton",
            start: "allDaysButton day1Button,day2Button,day3Button",
          }}
          resources={this.state.resources}
          initialView={"allConferenceDays"}
          views={this.views}
          dayHeaders={true}
          dayHeaderFormat={{
            month: "short",
            day: "numeric",
          }}
          datesAboveResources={true}
          slotDuration={this.state.calendarResolution}
          slotLabelInterval={"00:15:00"}
          //   scrollTime={formattedCurrentTimeForFC()}
          validRange={{
            start: "2023-12-15",
            end: "2023-12-18",
          }}
          selectLongPressDelay={1000}
          longPressDelay={1000}
          selectable={!this.state.isBusy && this.props.isAdmin}
          selectMirror={true}
          unselectAuto={true}
          selectOverlap={false}
          select={this.handleCreateNewEvent}
          slotMinTime="08:00:00"
          slotMaxTime="20:00:00"
          // now={new Date().setFullYear(2023, 11, 15)}
          // nowIndicator={true}
          allDaySlot={false}
          eventChange={(changeInfo) => {
            this.updateSessionMetadata(
              changeInfo.event.id,
              changeInfo.event.start,
              changeInfo.event.end,
              changeInfo.event._def.resourceIds[0],
              changeInfo
            );
          }}
          events={this.state.events}
          eventOverlap={false}
          eventClick={this.handleEventClick}
          eventContent={this.renderEventContent}
          editable={this.props.isAdmin && !this.state.isBusy}
          eventMouseEnter={(mouseEnterInfo) => {
            this.setState({
              currentlyHoveringMouseSessionId: mouseEnterInfo.event.id,
            });
          }}
          eventMouseLeave={(mouseLeaveInfo) => {
            this.setState({
              currentlyHoveringMouseSessionId: null,
            });
          }}
        />
      </div>
    );
  };
  renderLeftPanel = () => {
    if (this.state.mode === "ADD") {
      return (
        <div
          style={{
            width: "24%",
            marginRight: "10px",
            overflowY: "scroll",
            overflow: "scroll",
            overflowX: "scroll",
          }}
        >
          {this.renderAllSubmissionsPanel()}
        </div>
      );
    } else if (this.state.mode === "CONFLICT") {
      return (
        <div
          style={{
            width: "30%",
            marginRight: "10px",
            overflowY: "scroll",
            overflow: "scroll",
            overflowX: "scroll",
          }}
        >
          {this.renderAllCommitmentsPanel()}
        </div>
      );
    } else {
      return null;
    }
  };
  renderAllSubmissionsPanel = () => {
    if (!this.state.loadedSubmissions.length) {
      return <Empty />;
    }
    return (
      <Space direction="vertical">
        <Tag>Submissions</Tag>
        {this.renderSubmissionControlBar()}
        <div
          style={{
            width: "100%",
            height: "55vh",
            marginRight: "10px",
            overflowY: "scroll",
            overflow: "scroll",
            overflowX: "scroll",
          }}
        >
          {this.renderSearchedSubmissionList()}
        </div>
      </Space>
    );
  };
  renderSubmissionControlBar = () => {
    let awardOptions = [
      { label: "KPR", value: "Dr K P Roy Competition for Papers" },
      { label: "BKM", value: "Dr B K Mitra Competition for Papers" },
      { label: "ABB", value: "Dr Anadi Bhushan Basu Competition for Posters" },
      { label: "SDG", value: "Smt Sovabati Das Ghosh Competition for Videos" },
    ];
    let submissionTypeOptions = [
      {
        label: "Paper",
        value: "PAPER",
      },
      {
        label: "Video",
        value: "VIDEO",
      },
      { label: "IC", value: "IC" },
      { label: "THESIS", value: "THESIS" },
    ];
    return (
      <Space.Compact direction="vertical">
        Search Title:
        <Input
          allowClear={true}
          size="medium"
          value={this.state.submissionSearchInput}
          onChange={(e) => {
            this.setState(
              {
                submissionSearchInput: e.target.value,
              },
              () => {
                this.quickSearchSubmissions();
              }
            );
          }}
        ></Input>
        Type:
        <Select
          allowClear={true}
          options={submissionTypeOptions}
          onChange={(item) => {
            this.setState(
              {
                submissionFilterType: item,
              },
              () => {
                this.quickSearchSubmissions();
              }
            );
          }}
          style={{
            maxWidth: "100%",
          }}
        ></Select>
        Award Track:
        <Select
          allowClear={true}
          options={awardOptions}
          style={{
            maxWidth: "100%",
          }}
          onChange={(item) => {
            this.setState(
              {
                submissionFilterAward: item,
              },
              () => {
                this.quickSearchSubmissions();
              }
            );
          }}
        ></Select>
      </Space.Compact>
    );
  };
  renderSearchedSubmissionList = () => {
    if (!this.state.searchedSubmissions.length) {
      return <Empty />;
    }
    let data = this.state.searchedSubmissions;
    return (
      <List
        size="small"
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => {
          // check if _id of item is currently selected
          let current = this.state.currentlySelectedSubmissionIds;
          let isSelected = current.includes(item._id);
          return (
            <List.Item key={index}>
              <List.Item.Meta
                title={item.title}
                description={
                  <div
                    style={{
                      backgroundColor: `${isSelected ? "#D4F17E" : "white"}`,
                    }}
                  >
                    <Button
                      size="small"
                      icon={
                        isSelected ? <CheckSquareOutlined /> : <MoreOutlined />
                      }
                      onClick={() => {
                        if (isSelected) {
                          let newSelected = current.filter(
                            (each) => each !== item._id
                          );
                          this.setState({
                            currentlySelectedSubmissionIds: newSelected,
                          });
                        } else {
                          this.setState({
                            currentlySelectedSubmissionIds: [
                              ...current,
                              item._id,
                            ],
                          });
                        }
                      }}
                    ></Button>
                    {item.presentingAuthorName}
                    <br />
                    <Tag color="green">
                      {_.startCase(_.lowerCase(item.submissionType))}
                    </Tag>
                    <br />
                    {item.awardTrack}
                  </div>
                }
              />
            </List.Item>
          );
        }}
      />
    );
  };
  renderAllCommitmentsPanel = () => {
    if (!this.state.commitments.length) {
      return <Empty />;
    }
    return (
      <Space direction="vertical">
        <Tag>Commitments</Tag>
        {this.renderCommitmentControlBar()}
        <div
          style={{
            width: "98%",
            height: "75vh",
            marginRight: "10px",
            overflowY: "scroll",
            overflow: "scroll",
            overflowX: "scroll",
          }}
        >
          {" "}
          {this.renderCommitments()}
        </div>
      </Space>
    );
  };
  renderCommitmentControlBar = () => {
    return (
      <Space.Compact direction="vertical">
        Search Delegate:
        <Input
          allowClear={true}
          size="medium"
          value={this.state.commitmentDelegateSearch}
          onChange={(e) => {
            this.setState({
              commitmentDelegateSearch: e.target.value,
            });
          }}
        ></Input>
      </Space.Compact>
    );
  };
  renderCommitments = () => {
    if (!this.state.commitments.length) {
      return <Empty />;
    }
    let data = this.state.commitments;
    let filteredData = data;
    if (
      this.state.commitmentDelegateSearch &&
      this.state.commitmentDelegateSearch.length > 2
    ) {
      filteredData = data.filter((each) => {
        let name = each.delegateInfo.name;
        name = name.toLowerCase();
        let search = this.state.commitmentDelegateSearch.toLowerCase();
        return name.includes(search);
      });
    }
    return (
      <List
        size="small"
        bordered={true}
        itemLayout="vertical"
        dataSource={filteredData}
        renderItem={(item, index) => {
          let sessions = item.sessions;
          let nConflict = 0;
          for (var i = 0; i < sessions.length; i++) {
            if (sessions[i].hasConflict) {
              nConflict++;
            }
          }
          return (
            <List.Item key={index}>
              <List.Item.Meta
                title={
                  item.hasConflict ? (
                    <Badge count={nConflict} offset={[12, -1]}>
                      {item.delegateInfo.name}
                    </Badge>
                  ) : (
                    <> {item.delegateInfo.name}</>
                  )
                }
              />
              <Commitments
                onSelectSessionId={(sessionId) => {
                  this.setState({
                    currentlySelectedSessionId: sessionId,
                  });
                }}
                data={item}
                context={this.props.context}
                isAdmin={this.props.isAdmin}
              />
            </List.Item>
          );
        }}
      />
    );
  };
  render() {
    return (
      <div>
        {this.renderSelectedSessionDrawer()}
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            width: "100%",
            height: "80vh",
          }}
        >
          {this.renderLeftPanel()}
          {this.renderCalendar()}
        </div>
      </div>
    );
  }
}

export default SchedulerLayout;
